import { __assign } from "tslib";
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { DisplayError } from '../../basic/DisplayError/index.js';
import { Spinner } from '../../components/Spinner/index.js';
import { StepIndicator } from '../../components/StepIndicator/index.js';
import { useAsyncReplace } from '../../hooks/useAsyncReplace.js';
import { usePrompt } from '../../hooks/usePrompt.js';
import { isDifferent } from '../../utils.js';
export function StepForm(props) {
    var initialForm = React.useState(props.initial)[0];
    var _a = React.useState(initialForm), form = _a[0], setForm = _a[1];
    var _b = React.useState(0), step = _b[0], setStep = _b[1];
    var history = useHistory();
    var _c = useAsyncReplace(function () { return props.onSubmit(form); }, function () { return (reset(), setStep(0), setForm(initialForm)); }), creating = _c[0], create = _c[1], error = _c[2], reset = _c[3];
    React.useLayoutEffect(function () {
        var _a;
        (_a = document.body.querySelector('form input')) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    var discard = props.discardMessage || 'Really discard the data?';
    var labels = props.sections.map(function (m) { return m.label; });
    var Section = props.sections[step].Section;
    usePrompt(!creating && isDifferent(form, initialForm), history, discard);
    var changeForm = function (newForm) {
        setForm(__assign(__assign({}, form), newForm));
    };
    if (creating) {
        return React.createElement(Spinner, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StepIndicator, { labels: labels, active: step, mode: "vertical" },
            React.createElement("div", { className: "stepper-content-form" },
                React.createElement(Section, { step: step, form: form, submit: create, changeForm: changeForm, changeStep: setStep }))),
        React.createElement(DisplayError, { error: error })));
}
//# sourceMappingURL=index.js.map